export default __webpack_public_path__ + "static/media/youtube_landing04.d50c1fd2.png";